import { Box, CircularProgress, Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../store";
import { adminCheckAuth } from "../store/slices/adminAuthSlice";

const ProtectedRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user, isAuthenticated, loading } = useAppSelector(
    (state) => state.adminAuth,
  );
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect((): void => {
    const token = localStorage.getItem("admin-token");

    if (token && !isAuthenticated) {
      // Если есть токен но пользователь не аутентифицирован, проверяем токен
      dispatch(adminCheckAuth()).finally(() => {
        setIsInitializing(false);
      });
    } else {
      // Если нет токена или уже аутентифицирован
      setIsInitializing(false);
    }
  }, [dispatch, isAuthenticated]);

  // Показываем загрузку пока идет начальная проверка
  if (isInitializing || loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Если не аутентифицирован, перенаправляем на логин
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Проверить, что пользователь является администратором
  if (user && user.role !== "ADMIN") {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        p={3}
      >
        <Alert severity="error" sx={{ mb: 2 }}>
          Access Denied: Admin privileges required
        </Alert>
        <p>You do not have permission to access the admin panel.</p>
      </Box>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
